/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kuendigunggrund1Inputs */

const de__field_kuendigunggrund1 = /** @type {(inputs: _Field_Kuendigunggrund1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigungsgrund`)
};

/**

* @param {_Field_Kuendigunggrund1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kuendigunggrund1 = /** @type {((inputs?: _Field_Kuendigunggrund1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kuendigunggrund1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kuendigunggrund1(inputs)
});
export { _field_kuendigunggrund1 as "_field_kuendigungGrund" }